module.exports = __webpack_public_path__ + "image_placeholder.5a8fc0b4d404bd325888.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/assets/img/image_placeholder.jpg
// module id = ../../../../../src/assets/img/image_placeholder.jpg
// module chunks = styles